import type {Context} from '../types';

const isRef = (xattr: any) => xattr.name === 'ref';
const refToRel = (xattr: any) =>
  isRef(xattr) ? {...xattr, name: 'rel'} : xattr;

// Removes unallowed custom attribute `ref`
export default (context: Context) => {
  const {
    node: {
      jsonNode: {data: nodeData = {}, _id},
    },
  } = context;

  const customAttributes = nodeData.xattr;
  const hasRefCustomAttr = Boolean(
    customAttributes &&
    customAttributes instanceof Array &&
    customAttributes.find(isRef)
  );

  return {
    needed: hasRefCustomAttr,
    logData: {
      msg: 'Replace `ref` custom attributes',
      meta: {
        nodeId: _id,
      },
    },
    apply: () => {
      nodeData.xattr = nodeData.xattr.map(refToRel);
    },
  };
};
